<template>
  <v-dialog v-model="open" persistent max-width="500px">
    <v-card>

      <v-card-title>Send Customer Number Reserve Mail</v-card-title>

      <v-card-text class="py-4 text-center">Are you sure you want to send the customer a Number Reserve Mail?</v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn color="primary" small :loading="getSendCustomerNumberReserveMailLoading" :disabled="getSendCustomerNumberReserveMailLoading" @click="send">SEND</v-btn>
        <v-btn color="primary" small :disabled="getSendCustomerNumberReserveMailLoading" outlined @click="closeDialog()">CANCEL</v-btn>
      </v-card-actions>

    </v-card>
  </v-dialog>
</template>

<script>
  import { mapActions, mapGetters} from 'vuex';

  export default {
    props: {
      open: {
        type: Boolean,
        default: false
      },
    },

    computed: {
      ...mapGetters('products', ['getCurrentProduct']),
      ...mapGetters('numbers', ['getSendCustomerNumberReserveMailLoading', 'getSendCustomerNumberReserveMailError']),
    },

    methods: {
      ...mapActions('numbers', ['sendCustomerNumberReserveMail']),

      async send() {
        await this.sendCustomerNumberReserveMail({p_id: this.getCurrentProduct.id});
        if (!this.getSendCustomerNumberReserveMailError) {
          this.closeDialog();
        }
      },

      closeDialog() {
        this.$emit('closeDialog');
      }
    }    
  }
</script>